import React from 'react'
import './download-section.scss'
import { StaticImage } from 'gatsby-plugin-image'
import useMediaQuery from '@/utils/useMediaQuery'
import corazonCreciente from '../../../assets/images/contenidos-descargables/corazon-creciente.png'
import rightRow from '../../../assets/images/contenidos-descargables/right-row.svg'
import dataCards from './dataCards'
import { callModal } from '../modal-viewer/modal-viewer'
import useUserLogged from '@/hooks/useUserLogged'
import { triggerTageo } from '@/utils/tagging-util'

const getImagePreview = idImage => {
  let imageComponent = null

  switch (idImage) {
    case 1:
      imageComponent = (
        <StaticImage
          src="../../../assets/images/contenidos-descargables/ebook.webp"
          alt="resources"
          className="f-banner-consulting-image"
          placeholder="blurred"
          width={200}
        />
      )
      break
    case 2:
      imageComponent = (
        <StaticImage
          src="../../../assets/images/contenidos-descargables/resources.webp"
          alt="resources"
          className="f-banner-consulting-image"
          placeholder="blurred"
          width={200}
        />
      )
      break
    case 3:
      imageComponent = (
        <StaticImage
          src="../../../assets/images/contenidos-descargables/stickers.webp"
          alt="resources"
          className="f-banner-consulting-image"
          placeholder="blurred"
          width={200}
        />
      )
      break
    default:
      break
  }

  return imageComponent
}

const CardItem = ({ card }) => {
  const isMobile = useMediaQuery()
  const [isLogged] = useUserLogged()

  const downloadNow = () => {
    triggerTageo('10A', {
      label: '¡lo quiero!',
      content_name: card.title,
      location:
        window.location.host + window.location.pathname + '#descargables',
    })
    callModal('download', { card: card })
    setTimeout(() => {
      window.open(card.link, '_blank')
    }, 500)
  }

  const HandleOnclick = event => {
    event.preventDefault()

    if (card.requireLogin && !isLogged) {
      callModal('login', {
        forAccess: card.forAccess,
        onClose: logged => {
          if (logged) {
            downloadNow()
          }
        },
      })
    } else {
      downloadNow()
    }
  }

  return (
    <div className="card-download">
      <div className="card-download-image">{getImagePreview(card.id)}</div>
      <div className="card-download-description">
        <div className="card-download-description-wrap">
          <h2 className="card-download-description-title">{card.title}</h2>
          <div className="card-download-description-items">
            {card.items.map((item, index) => {
              return (
                <p key={card.id + index}>
                  {' '}
                  <img src={corazonCreciente} alt="heart" /> {item}
                </p>
              )
            })}
          </div>
        </div>

        <a onClick={HandleOnclick} className="card-download-link">
          {!isMobile ? (
            '¡Lo quiero!'
          ) : (
            <>
              Descárgalo aquí <img src={rightRow} alt="download" />
            </>
          )}
        </a>
      </div>
    </div>
  )
}

const DownloadSection = () => {
  const downloadCards = dataCards.map((card, index) => (
    <CardItem card={card} key={index}></CardItem>
  ))

  return (
    <>
      <div className="section-background">
        <div className="f-download-section">
          <div className="f-download-section-text">
            <h2>CONTENIDO EXCLUSIVO PARA DETENER EL BULLYING </h2>
          </div>
          <div className="f-download-section-cards">{downloadCards}</div>
        </div>
      </div>
    </>
  )
}

export default DownloadSection
